import { withChartLayout } from 'components/common';
import AIMS from 'components/features/chart/special-charts/aims/AIMS';

const AIMSPage = withChartLayout('AIMS')(AIMS);
export default AIMSPage;
